import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import selectors from './rootSelectors';
import * as appActions from './AppActions';
import {
    setCurrentLanguage,
    setExternalURLStatus,
    setInitialQueryParams,
    setBenchmarkModeStatus,
    setBenchmarkId,
    setShouldEnableCaptions,
    setArLanguage,
    showSettingsPopup,
    hideSettingsPopup,
} from './common/screen/screenActions';
import App from './App';
import { setLocalizationLanguage } from './common/localization';
import { trackLogOut } from './common/lrs/lrsActions';
import { clearState } from './AppStateActions';
import { MAZE } from './constants/measure';
import { showErrorInChromeOSWithoutKiosk, showVerifiedAccessKioskError } from './AppActions';

const mapStateToProps = state => ({
    isPlaylistDataFetched: selectors.getIsPlaylistDataFetched(state),
    isResultDataFetched: selectors.getIsResultDataFetched(state),
    isLanternUser: selectors.getIsLanternUser(state),
    playlist: selectors.getPlaylistItems(state),
    isAvatarReadyToAnimate: selectors.getIsAvatarReadyToAnimate(state),
    studentName: selectors.getUserName(state),
    studentGrade: selectors.getGrade(state),
    currentLanguage: selectors.getCurrentLanguage(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    initialQueryParams: selectors.getInitialQueryParams(state),
    captionsEnabled: selectors.getShouldEnableCaptions(state),
    isSettingsPopupVisible: selectors.getisSettingsPopupVisible(state),
    hasSecureAssessments: selectors.hasSecureAssessments(state),
    currentSchoolyear: selectors.getSchoolYear(state),
    mazeSchoolId: selectors.getInstId(state, MAZE.MEASURE),
    isAvatarSpeaking: selectors.getAvatarSpeaking(state),
    isMazeLicensed: selectors.isMeasureLicensed(state, MAZE.MEASURE),
    hasUserInteracted: selectors.getHasUserInteracted(state),
});

const mapDispatchToProps = dispatch => ({
    fetchApplicationData: () => {
        dispatch(appActions.fetchApplicationData());
    },
    showSettingsPopup: () => {
        dispatch(showSettingsPopup());
    },
    hideSettingsPopup: () => {
        dispatch(hideSettingsPopup());
    },
    clearState: () => {
        dispatch(clearState());
    },
    setCurrentLanguage: language => {
        dispatch(setCurrentLanguage(language));
        setLocalizationLanguage(language);
    },
    setExternalURLStatus: () => {
        dispatch(setExternalURLStatus());
    },
    setInitialQueryParams: params => {
        dispatch(setInitialQueryParams(params));
    },
    setBenchmarkModeStatus: benchmarkMode => {
        dispatch(setBenchmarkModeStatus(benchmarkMode));
    },
    setArLanguage: language => {
        dispatch(setArLanguage(language));
    },
    trackLogOut: () => {
        dispatch(trackLogOut());
        return Promise.resolve();
    },
    setBenchmarkId: id => {
        dispatch(setBenchmarkId(id));
    },
    setShouldEnableCaptions: captions => dispatch(setShouldEnableCaptions(captions)),
    showErrorInChromeOSWithoutKiosk: () => dispatch(showErrorInChromeOSWithoutKiosk()),
    showVerifiedAccessKioskError: () => dispatch(showVerifiedAccessKioskError()),
});
const AppContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(App));

export default AppContainer;
